/* CONCEPTS */
export const MONITOR_SUPPLIER_LOAD = "MONITOR_SUPPLIER_LOAD";
export const MONITOR_SUPPLIER_LOAD_SUCCESS = "MONITOR_SUPPLIER_LOAD_SUCCESS";
export const MONITOR_SUPPLIER_ERROR = "MONITOR_SUPPLIER_ERROR";
export const MONITOR_SUPPLIER_CLEAN = "MONITOR_SUPPLIER_CLEAN";